import { OrganizationsApi } from "@/api/organizations/OrganizationsApi";
import { queryKeys } from "@/api/queryKeys";
import { useAuth } from "@/auth/AuthContext";
import { useQuery } from "@tanstack/react-query";

export function useMyOrganizations() {
  const { user } = useAuth();
  const userId = user?.id ?? "";
  const q = useQuery({
    queryKey: queryKeys.organizations.my(userId),
    queryFn: () => OrganizationsApi.listMyMemberships(userId),
    enabled: !!userId,
    staleTime: 30_000,
  });

  const memberships = q.data ?? [];
  const organizations = memberships
    .filter((m) => m.status === "active" && m.organization)
    .map((m) => m.organization!);

  return {
    memberships,
    organizations,
    loading: q.isLoading,
    error: q.error,
    refetch: q.refetch,
  };
}
